import * as z from 'zod';

export const CreateClientSchema = z.object({
  id: z.string().optional(),
  name: z.string().min(1, {
    message: 'Name is required',
  }),
  address: z.string().min(1, {
    message: 'Address is required',
  }),
  city: z.string().min(1, {
    message: 'City is required',
  }),
  country: z.string().min(1, {
    message: 'Country is required',
  }),
  zipCode: z.string().min(1, {
    message: 'Zip code is required',
  }),
  taxNumber: z.string().min(1, {
    message: 'Tax number is required',
  }),
  registrationNumber: z.string().optional(),
});
